export var reopened = 'reopened';
export var pending = 'pending';
export var reviewed = 'approved';
//# sourceMappingURL=reviewstatus.js.map


//////////////////
// WEBPACK FOOTER
// ../gipsy-misc/lib/utils/reviewstatus.js
// module id = 198
// module chunks = 0